// extracted by mini-css-extract-plugin
export default {"container":"CarCard_container__wggJm","containerInfo":"CarCard_containerInfo__w4lsM"};